import { InlineText1 } from '@cian/ui-kit/typography/InlineText';

import { FC } from 'react';

import { IOperatorDescriptionProps } from './types';

export const OperatorDescription: FC<IOperatorDescriptionProps> = props => {
  const { phoneNumber } = props;

  return (
    <>
      <InlineText1 as="span" color="black_100" fontWeight="normal">
        Оператор коворкинга свяжется с вами в рабочее время
      </InlineText1>
      {phoneNumber && (
        <InlineText1 as="span" color="black_100" fontWeight="normal">
          по номеру {phoneNumber}
        </InlineText1>
      )}
    </>
  );
};

OperatorDescription.displayName = 'OperatorDescription';
